import { render, staticRenderFns } from "./LoadingBar.vue?vue&type=template&id=579cae39"
import script from "./LoadingBar.vue?vue&type=script&lang=js"
export * from "./LoadingBar.vue?vue&type=script&lang=js"
import style0 from "./LoadingBar.vue?vue&type=style&index=0&id=579cae39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports